<template>
    <div class="modal-overlay" @click.self="closeModal">
        <div class="modal-content">
            <div class="modal-header">
                <div class="project-status-text" :class="`status-${project.status}`">
                    {{ getStatusDisplayName(project.status) }}
                </div>
                <h1 class="modal-title">{{ project.name }}</h1>
                <div class="project-location">
                    <img v-if="getLocationIcon(project.district)" :src="getLocationIcon(project.district)" :alt="getLocationDisplayName(project.district) + ' Wappen'" class="location-icon">
                    <span class="location-name">{{ getLocationDisplayName(project.district) }}</span>
                </div>
            </div>

            <div class="modal-body">
                <!-- Project Map - only show if project has valid location -->
                <div v-if="hasValidLocation" class="project-location-map">
                    <div class="mini-map">
                        <InteractiveMap 
                            :active-filters="[]"
                            :focused-project="project"
                            :is-static="true"
                            :static-zoom="18"
                            @project-clicked="() => {}"
                        />
                    </div>
                </div>
                
                <div class="project-description">
                    <p>{{ project.description }}</p>
                </div>
            </div>

            <div class="modal-footer">
                <button class="btn-close-modal" @click="closeModal">
                    schließen
                </button>
            </div>

        </div>
    </div>
</template>

<script>
import InteractiveMap from '@/components/InteractiveMap.vue'

export default {
    name: 'ProjectModal',
    components: {
        InteractiveMap
    },
    props: {
        project: {
            type: Object,
            required: true
        }
    },
    computed: {
        hasValidLocation() {
            const lat = parseFloat(this.project.lat)
            const lng = parseFloat(this.project.lng)
            return !isNaN(lat) && !isNaN(lng) && this.project.lat !== "" && this.project.lng !== ""
        }
    },
    methods: {
        closeModal() {
            this.$emit('close')
        },
        handleEscape(event) {
            if (event.key === 'Escape') {
                this.closeModal()
            }
        },
        getLocationDisplayName(location) {
            const names = {
                'niederissigheim': 'Niederissigheim',
                'oberissigheim': 'Oberissigheim', 
                'rossdorf': 'Roßdorf',
                'butterstadt': 'Butterstadt',
                'innenstadt': 'Innenstadt'
            }
            return names[location?.toLowerCase()] || location
        },
        getStatusDisplayName(status) {
            const names = {
                'abgeschlossen': 'Abgeschlossen',
                'geplant': 'Geplant',
                'laufend': 'Laufend'
            }
            return names[status] || status
        },
        getLocationIcon(location) {
            const icons = {
                'niederissigheim': '/images/Wappen_Niederissigheim.svg',
                'oberissigheim': '/images/Wappen_Oberissigheim.svg',
                'rossdorf': '/images/Wappen_Roßdorf.svg',
                'butterstadt': '/images/Wappen_Butterstadt.svg',
                'innenstadt': '/images/Wappen_Innenstadt.svg'
            }
            return icons[location?.toLowerCase()] || null
        }
    },
    mounted() {
        // Prevent body scrolling when modal is open
        document.addEventListener('keydown', this.handleEscape)
    },
    beforeUnmount() {
        document.removeEventListener('keydown', this.handleEscape)
    },
}
</script>

